import { KYMW5400Model } from '../kymw5400.model';
import { KYMW5400commonModel } from '../vo/kymw5400-common.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/* カテゴリマスタ取得 */
@Injectable()
export class GetGoodsCategoryInfoService extends PlessJsonResponderSub<any> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /** 処理に使用するModel */
  private model: KYMW5400Model;
  private vo: KYMW5400commonModel;
  private successFunc: Function;

  private getBody():PlessRequest {
    return new PlessRequest({
      search: {
        Rec: {
          condition: {
            OrderCode: this.vo.orderCode,
            CategoryCode: this.vo.categoryCode,
          }
        }
      }
    })
  }

  /** APIを呼ぶ */
  execute(model: KYMW5400Model, vo: KYMW5400commonModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGoodsCategoryInfo', this.getBody());
  }

  /** API通信成功時の処理(PlessResponderのメソッドをオーバーライド) */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc();
    }
    if (data !== null) {
      this.model.getGoodsCategory(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetGoodsCategoryInfoService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }

}
